import Hero from '../../components/Hero';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
import Partners from '../../components/Partners';
import CookieBanner from '../../components/CookieBaner';
import PriceTable from '../../components/Content/PriceTable';
import Gallery from '../../components/Gallery';
import { housesImages } from "../../components/Content/Houses/images/housesImages";
import { Container } from '../../components/Content/styled';
import HousesHero480 from "./images/housesHero480p.webp";
import HousesHero768 from "./images/housesHero768p.webp";
import HousesHero1080 from "./images/housesHero1080p.webp";
import HousesHero1440 from "./images/housesHero1440p.webp";
import GoogleMap from '../../components/Content/GoogleMap';
import Address from '../../components/Content/Address';
import Houses from '../../components/Content/Houses';

function HousesPage() {
    return (
        <>
            <NavigationBar variant="houses" />
            <main>
                <Hero variant="houses" images={{
                    480: HousesHero480,
                    768: HousesHero768,
                    1080: HousesHero1080,
                    1440: HousesHero1440,
                }} />
                <Container>
                    <Houses />
                    <PriceTable variant="houses" />
                    <Address variant="houses" />
                    <GoogleMap variant="houses" />
                </Container>
                <Gallery images={housesImages} variant="houses" />
                <Partners />
            </main>
            <Footer />
            <CookieBanner />
        </>
    );
}
export default HousesPage;